<template src="./html/Requests.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Create from '@/components/requests/views/Create.vue'
	import Edit from '@/components/requests/views/Edit.vue'
	import Show from '@/components/requests/views/Show.vue'
	import Navbar from '@/components/customers/views/Navbar.vue'
	import VueElementLoading from 'vue-element-loading'

	import Datatable from '@/components/requests/views/Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'create': Create,
			'edit': Edit,
			'show': Show,
			'navbar': Navbar,
			'loading': VueElementLoading,
			'datatable': Datatable,
		},
		data () {
			return {
				data: null,
				item: null,
				loading: false,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
				this.getCustomer()
			},
			reload() {
				this.getData()
				this.getCustomer()
			},
			getData() {
				this.loading = true
				this.$http.get('admin/customers/' + this.$route.params.id + '/requests')
				.then(response => {
					this.loading = false
					this.data = response.body
					this.$nextTick( () => this.loadDropdowns())
				}).catch(function(response) {
					this.loading = false
					console.log(response)
				})
			},
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			getCustomer() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			//--
			destroy(data) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/requests/' + data.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			addBudget(request) {
				var that = this
				var data = {
					customer_id: this.item.id,
					request_id: request.id,
				}
				swal.queue([{
					title: this.$t("messages.attention"),
					text: this.$t("messages.budget_will_be_created"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/budgets', data)
							.then(response => {
								that.reload()
								that.editOrContinue(response, 'budget')
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			editOrContinue(response, type) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
				}).catch(swal.noop)
			},
			openEditRequest(request) {
				this.$refs.edit.open(request)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Requests.vue